module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "agency-main"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("一、是否为下列机构")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "padding": "10px"
    }
  }, [_vm._v("\n          符合《证券期货投资者适当性管理办法》第八章第（一）款所规定的证券公司、期货公司、基金管理公司及其子公司、商业银行、保险公司、信托公司、财务公司；\n          或在中国证券投资基金业协会登记或者备案的证券公司子公司、期货公司子公司、私募基金管理人；或者第（三）款所规定的合格境外机构投资者（QFII），人名币合格境外机构投资者（RQFII）\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isProfessionalInvestors.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isProfessionalInvestors, "checked", $$v)
      },
      expression: "data.isProfessionalInvestors.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": "",
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": "",
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("二、机构资产规模？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "padding": "10px"
    }
  }, [_vm._v("\n          私募基金或者资产管理计划投资者，最近三个月月末资产均超过（含）人名币1000万元\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.orgAssetsScale.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.orgAssetsScale, "checked", $$v)
      },
      expression: "data.orgAssetsScale.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("三、是否存在实际控制关系？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isControllingShareholder.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isControllingShareholder, "checked", $$v)
      },
      expression: "data.isControllingShareholder.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.isControllingShareholder.checked === '是'),
      expression: "data.isControllingShareholder.checked === '是'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.isControllingShareholder.description),
      callback: function($$v) {
        _vm.$set(_vm.data.isControllingShareholder, "description", $$v)
      },
      expression: "data.isControllingShareholder.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("四、交易实际受益人？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.transactionActualBeneficiary.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.transactionActualBeneficiary, "checked", $$v)
      },
      expression: "data.transactionActualBeneficiary.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "本机构"
    }
  }, [_c('my-check-style', [_vm._v("本机构")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "其他机构或个人"
    }
  }, [_c('my-check-style', [_vm._v("其他机构或个人")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.transactionActualBeneficiary.checked === '其他机构或个人'),
      expression: "data.transactionActualBeneficiary.checked === '其他机构或个人'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.transactionActualBeneficiary.description),
      callback: function($$v) {
        _vm.$set(_vm.data.transactionActualBeneficiary, "description", $$v)
      },
      expression: "data.transactionActualBeneficiary.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("五、是否有不良诚信记录？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isBadFaith.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isBadFaith, "checked", $$v)
      },
      expression: "data.isBadFaith.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.isBadFaith.checked === '是'),
      expression: "data.isBadFaith.checked === '是'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.isBadFaith.description),
      callback: function($$v) {
        _vm.$set(_vm.data.isBadFaith, "description", $$v)
      },
      expression: "data.isBadFaith.description"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_agency_submit
    }
  }, [_vm._v("提 交")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7646aae9"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorInfo/Agency/Question.vue
// module id = 1071
// module chunks = 1